import * as React from 'react';
import * as main from "../../main.module.scss";
import * as screen1 from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import { WebDate } from "../../../../WebDate";
import {Modal} from "../../../../Modal";
export const Screen1 = ({ widget, id }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel phoneColor={'#6F00E2'}/>
        <div className={screen1.desc}>
          <p className={screen1.time}>
            <WebDate id={id}/>
          </p>
          <div className={screen1.titles}>
            <small className={screen1.type}>Бесплатный вебинар</small>
            <h1>Научите детей<br/>учиться</h1>

            <small className={`${screen1.sub} ${screen1.top}`}>для <b>осознанных</b></small>
            <small className={`${screen1.sub} ${screen1.bottom}`}>родителей и педагогов</small>

            <button className={main.btn} onClick={()=>{setShowModal(true)}}>Зарегистрироваться</button>
            <p style={{marginTop: "20px"}}>Подарок за&nbsp;регистрацию:<br/>Чек-лист «5&nbsp;шагов, чтобы&nbsp;ребенок учился&nbsp;сам»</p>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
